<template lang="pug">
  .final-report-upload(v-loading="loading")
    campaign-info
    title-bar
      span {{ isView ? $t('结案信息') : $t('上传结案信息') }}
      el-button(
        type="text"
        @click="quotationVisible = true"
      ) {{ $t('查看报价') }}

    div(style="margin-left: 20px")
      el-row(v-if="!isView && hasSync")
        el-col(:span="4") {{ $t('同步结案信息') }}
        el-col(:span="4")
          el-progress(
            v-if="isSyncing"
            :percentage="syncPercentage"
          )
          div.final-report-upload__sync(
            v-else
            @click="sync"
          )
            i.iconfont.icon-jinhangzhong
            span {{ $t('点击同步') }}
            el-tooltip(
              :content="$t('“点击同步”将从UniDam系统同步相关项目结案信息')"
              placement="top"
              :style="{ marginLeft: '5px' }"
            )
              i.el-icon-question
      upload-multiple-file(
        v-if="isView || isPull"
        :text="$t('结案信息')"
        :fileName="log.file_name"
        :downloadUrl="log.download_url"
        :files="log.file_name_list"
      )
      upload-multiple-file(
        v-if="!hasSync && !isView"
        axiosUrl="/management/subfinal/saveFile"
        :params="uploadParams"
        :text="$t('结案信息')"
        @success="uploadSuccess"
        @uploading="loading = true"
      )
      template(v-if='uploadMaterialFlag')
        upload-multiple-file(
          v-if="isView && log.material_desc_path"
          :text="$t('材料说明')"
          :isRequired="uploadMaterialFlag"
          :fileName="log.material_file_name"
          :downloadUrl="log.material_download_url"
          :files="log.material_file_name_list"
        )
        upload-multiple-file(
          v-else
          :isRequired="uploadMaterialFlag"
          axiosUrl="/management/subfinal/saveFile"
          :params="uploadMaterial"
          :text="$t('材料说明')"
          @success="uploadMaterialSuccess"
          @uploading="loading = true"
        )
      el-row(v-if="isView || isPull  || !hasSync || (hasSync && syncSuccess)")
        el-col(:span="4") {{ $t('完成情况') }}
        el-col(:span="20")
          kpi-situation(
            v-model="kpi"
            :viewData="kpi"
            :isEdit="(!isView && !hasSync) || (!isView && hasSync &&!syncSuccess)"
          )

      el-row(v-if="(syncSuccess || isView || isPull) && matterTable")
        el-col(:span="4") {{ $t('素材管理') }}
        el-col(:span="20")
          el-table(:data="matterTable")
            el-table-column(
              :label="$t('服务项目')"
              prop="service_item_name"
            )
            el-table-column(
              :label="$t('报价数量')"
              prop="number"
            )
              template(slot-scope="scope")
                span {{ scope.row.number ? scope.row.number : '—' }}
            el-table-column(
              :label="$t('完成数量')"
              prop="complete_num"
            )
              template(slot-scope="scope")
                span {{ scope.row.complete_num ? scope.row.complete_num : '—' }}

    template(v-if="quotationVisible")
      title-bar
        span {{ $t('报价') }}
      div(style="margin-left: 20px")
        el-row(style="margin:30px 0")
          el-col(:span="20" :offset="4")
            el-button(@click="onStartQuotationEdit") {{ isView ? $t('查看报价') : $t('修改报价') }}
        el-row(style="margin:30px 0")
          el-col(:span="19" :offset="4")
            QuotationOverview(:data="quotation.price_overview")

    quotation-dialog(
      ref="quotationDialog"
      v-if="quotationDetail.length !== 0"
      :visible="editDialogVisible"
      :data="quotationDetail"
      :hasFilled="true"
      :viewMode="isView || !quotationEdit"
      @close="onClose"
      :checkIsAsset="true"
      :hasSync="hasSync"
    )

    el-row(style="margin-left: 20px")
      el-col(
        :span="20"
        :offset="4"
      )
        footer-button(
          v-if="!isView"
          @confirm="onConfirm"
          @cancel="$router.push('/vendor-campaign/process')"
        )
    audit-versions(
      :id="auditVersionId"
      :auditType="11"
      :businessType="campaign.businessType"
    )
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import SubFinalScope from '@/components/SubFinalScope'
import QuotationOverview from '@/components/QuotationOverview'
import { default as Dialog } from '@/components/QuotationList/QuotationDialog'
import KpiSituation from '@/components/KpiSituation'
import QuotationDialog, { normalizeQuotation, formatParams } from '@/components/QuotationDialog'
import { format4backend } from '@/umcc/util'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import ContractAndDoItem from '@/components/ContractAndDoItem'
import AuditVersions from '@/components/AuditVersions'
import CampaignInfo from './CampaignInfo'

const updateVendorQuotation = (params) =>
  axios.post('/management/subfinal/updateVendorQuotationForFinal', format4backend(params))

const submit = (params) =>
  axios.post('/management/subfinal/uploadFinalReport', format4backend(params))

const defaultMatterTable = [
  {
    service_item_name: '—',
    number: '—',
    complete_num: '—'
  }
]

export default {
  components: {
    TitleBar,
    SubFinalScope,
    KpiSituation,
    FooterButton,
    QuotationOverview,
    Dialog,
    QuotationDialog,
    UploadMultipleFile,
    ContractAndDoItem,
    AuditVersions,
    CampaignInfo
  },
  data () {
    return {
      scope: {},
      kpi: [],
      file: {},
      quotationVisible: false,
      quotationEdit: false,
      quotation: {},
      editDialogVisible: false,
      quotationDetail: [],
      log: {},
      loading: false,
      quotationParams: null,
      hasSync: false,
      syncPercentage: 0,
      isSyncing: false,
      syncSuccess: false,
      syncHasIncrement: null,
      matterTable: null,
      isPull: false,
      material: {},
      uploadMaterialFlag: false
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    },
    uploadParams () {
      return {
        campaign_id: this.campaignId,
        file_type: 6
      }
    },
    uploadMaterial () {
      return {
        campaign_id: this.campaignId,
        file_type: 21
      }
    },
    campaign () {
      return this.$store.state.campaign
    },
    auditVersionId () {
      switch (this.campaign.businessType) {
        case 1:
        case 5:
          return this.campaignId()
        case 2:
        case 6:
          return this.campaign.subFinalScopeId
        case 4:
        case 8:
          return this.campaign.subFinalScopeVendorId
      }
    },
    activePhaseType () {
      return this.$store.state.campaign.activePhaseType
    },
    phaseType () {
      return this.$store.state.campaign.phaseType
    },
    businessType () {
      return this.$store.state.campaign.businessType
    }
  },
  mounted () {
    this.checkIfSync()
    this.fetchQuotationOverview()
    this.fetchQuotationDetail()
    this.getKpiInfo()
    this.fetchAssets()
    this.fetchLog()
    this.checkMaterial()
  },
  methods: {
    getKpiInfo () {
      axios.get('/management/subfinal/getKpiInfo', {
        params: { sub_final_scope_id: this.$store.state.campaign.subFinalScopeId }
      })
        .then(res => {
          this.kpi = res
        })
        .catch(err => {
          throw new Error(err)
        })
    },
    checkMaterial () {
      axios.get('/management/subfinal/v3/checkMaterial', {
        params: { sub_final_scope_id: this.$store.state.campaign.subFinalScopeId }
      })
        .then(res => {
          this.uploadMaterialFlag = res.has_material
        })
        .catch(err => {
          throw new Error(err)
        })
    },
    checkIfSync () {
      axios
        .get('/management/subfinal/checkThirdParty', {
          params: {
            sub_final_scope_id: this.campaign.subFinalScopeId
          }
        })
        .then((res) => {
          this.hasSync = res.can_submit
          this.isPull = res.is_pull === 1
        })
    },
    sync () {
      this.syncPercentage = 0
      this.isSyncing = true
      let addPercent = setInterval(() => {
        this.syncPercentage += 2
        if (this.syncPercentage === 98) {
          clearInterval(addPercent)
        }
      }, 150)
      axios
        .get('/management/subfinal/pullFinalReport', {
          params: {
            sub_final_scope_id: this.campaign.subFinalScopeId
          }
        })
        .then((res) => {
          this.syncHasIncrement = res.has_increment
          this.syncPercentage = 100
          this.isSyncing = false
          this.syncSuccess = true
          this.isPull = true
          this.log = res
          this.file = res
          this.kpi = res.sub_final_scope_kpi
          this.matterTable = res.asset_list.length !== 0 ? res.asset_list : defaultMatterTable
          this.quotation = res.price
          this.quotationDetail = res.price.vendor_price.map(item => normalizeQuotation(item))
        })
        .catch(() => {
          clearInterval(addPercent)
          this.isSyncing = false
        })
    },
    fetchAssets () {
      axios.get('/management/subfinal/getAssetList', {
        params: {
          sub_final_scope_id: this.campaign.subFinalScopeId
        }
      })
        .then(res => {
          this.matterTable = res.length !== 0 ? res : defaultMatterTable
        })
    },
    fetchLog () {
      this.loading = true
      axios.get('/management/subfinal/getFinalReport', {
        params: {
          sub_final_scope_id: this.campaign.subFinalScopeId
        }
      })
        .then(res => {
          this.log = res
          this.file = res
          // this.kpi = res.sub_final_scope_kpi
          this.loading = false
        })
    },
    fetchQuotationOverview () {
      this.loading = true
      axios.get('/management/subfinal/getVendorPriceOverview', {
        params: { sub_final_scope_vendor_id: this.$store.state.campaign.subFinalScopeVendorId }
      })
        .then(res => {
          this.quotation = res
          this.loading = false
        })
    },
    async onConfirm () {
      if (!this.kpi.length || (this.kpi.length && this.kpi.find(i => (!i.actual || !i.actual_percent)))) {
        this.$message.error(this.$t('请填写完成情况'))
        return
      }

      // if (this.kpi.some(i => !checkIsNonnegativeInteger(i.actual_percent))) {
      //   this.$message.error(this.$t('完成比例必须为非负整数'))
      //   return
      // }

      if (!this.file.file_path) {
        console.log(this.log, this.file)
        this.$message.error(this.$t('请上传文件'))
        return
      }
      if (this.uploadMaterialFlag && !this.material.file_path) {
        this.$message.error(this.$t('请上传材料说明'))
        return
      }
      this.loading = true
      const params = {
        sub_final_scope_id: this.$store.state.campaign.subFinalScopeId,
        sub_final_scope_vendor_id: this.$store.state.campaign.subFinalScopeVendorId,
        file_path: this.file.file_path,
        servlet_path: this.$route.path,
        task_name: this.$store.state.campaign.taskName,
        task_id: this.$store.state.campaign.taskId,
        campaign_id: this.$store.state.campaign.id,
        email: this.$store.state.campaign.contact.market.mail,
        sub_final_scope_kpi: this.kpi.map(i => {
          const res = {
            kpi_id: i.kpi_id,
            target: i.target,
            actual: i.actual,
            actual_percent: i.actual_percent
          }
          if (i.file_path !== 'null' && i.file_path != null) res.file_path = i.file_path
          return res
        })
      }

      params.is_pull = this.isPull ? 1 : 0
      if (this.syncSuccess) {
        params.has_increment = this.log.has_increment
      }
      if (this.material.file_path) {
        params.material_desc_path = this.material.file_path
      }
      try {
        const incrementQuotationParams = formatParams(this.campaign.subFinalScopeVendorId, this.quotationDetail)
        const quotationParams = this.quotationParams ? this.quotationParams : incrementQuotationParams
        quotationParams.business_type = this.businessType
        await updateVendorQuotation(quotationParams)
        await submit(params)
        this.loading = false
        this.$router.push('/vendor-campaign/process')
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    uploadSuccess (res) {
      this.file = {
        file_download_path: res.file_download_path,
        file_name: res.file_name,
        file_path: res.file_path
      }
      this.loading = false
    },
    uploadMaterialSuccess (res) {
      this.material = {
        file_download_path: res.file_download_path,
        file_name: res.file_name,
        file_path: res.file_path
      }
      this.loading = false
    },
    onStartQuotationEdit () {
      if (this.isView) {
        this.editDialogVisible = true
        this.quotationEdit = true
      } else {
        this.$confirm(this.$t('更新报价需要重新审核，请确定是否继续?'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消')
        })
          .then(() => {
            this.editDialogVisible = true
            this.quotationEdit = true
          })
      }
    },
    fetchQuotationDetail () {
      this.loading = true
      axios.get('/management/subfinal/getVendorQuotation', {
        params: {
          sub_final_scope_vendor_id: this.$store.state.campaign.subFinalScopeVendorId,
          phase_current: this.activePhaseType,
          phase_reality: this.phaseType
        }
      })
        .then(res => {
          if (this.$store.state.campaign.taskId == null) {
            this.$store.commit('campaign/setTaskId', res.task_id)
          }
          this.quotationDetail = res.vendor_price.map(item => normalizeQuotation(item))
          this.loading = false
        })
    },
    onClose (res, params) {
      this.editDialogVisible = false
      if (res) {
        this.quotation = res
        this.quotationDetail = res.vendor_price.map(item => normalizeQuotation(item))
        this.quotationParams = params
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.title-bar
  display flex
  justify-content space-between

.final-report-upload__sync
  color $main
  cursor pointer
  > i
    margin-right 10px
</style>
